import * as React from 'react';
import { withDataFetch } from '../hoc/withDataFetch';
const ReactMapGL = React.lazy(() => import('react-map-gl'));

export interface MapWidgetProps {
  security: object | any;
  data: any;
  options: object;
}
const MapWidget: React.FC<MapWidgetProps> = ({ data, security }) => {
  const [mapViewPort, setMapViewport] = React.useState({});
  const [apiMapToken, setApiToken] = React.useState('');

  React.useEffect(() => {
    if (
      typeof security !== 'undefined' &&
      typeof security.apiToken !== 'undefined'
    ) {
      setApiToken(security.apiToken);
    }
    const { viewport } = data;
    setMapViewport(viewport);
  }, []);

  React.useEffect(() => {
    if (
      typeof security !== 'undefined' &&
      typeof security.apiToken !== 'undefined'
    ) {
      setApiToken(security.apiToken);
    }
  }, [security]);

  return (
    <>
      {apiMapToken.length > 0 && (
        <ReactMapGL
          {...mapViewPort}
          mapboxApiAccessToken={apiMapToken}
          onViewportChange={(viewport: any) => {
            setMapViewport(viewport);
          }}
        />
      )}
    </>
  );
};

export default withDataFetch(MapWidget);
